import {
  INITIAL_F2F_OPTION_SECTIONS,
  NOTE_CONTENT_OPTION_SECTIONS,
  NOTE_CONTENT_SECTION_KEYS,
} from "./initial-f2f-constant";

/** One form group as the report should lay it out: its title, under an optional uppercase heading. */
export interface SectionLayoutGroup {
  title: string;
  heading?: string;
}

const toLayout = (groups: { title: string; heading?: string }[]) =>
  groups.map(({ title, heading }) => ({ title, heading }));

/**
 * Report section key → the form's group order and headings, so the preview can
 * print "FALL RISK ASSESSMENT" above its questions the way the form does.
 */
export const INITIAL_F2F_SECTION_LAYOUTS: Record<string, SectionLayoutGroup[]> =
  Object.fromEntries(
    NOTE_CONTENT_OPTION_SECTIONS.map((key) => [
      NOTE_CONTENT_SECTION_KEYS[key],
      toLayout(INITIAL_F2F_OPTION_SECTIONS[key].groups),
    ])
  );
